import type { Task } from "../task";
import type { ChatTask } from "./chatTask";

export function isChatTask(task?: Task): task is ChatTask {
    return task?.type === "chat";
}
